.root {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  font-weight: 600;
  color: var(--ink);
  white-space: nowrap;
}

.dot {
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--tint);
}

/* Строка таблицы броней (prototype/Prototype.dc.html:588). Обводки нет. */
.sm {
  height: 24px;
  padding: 0 10px 0 8px;
  font-size: 11px;
  background: color-mix(in oklch, var(--tint) 15%, var(--tint-on));
}

/* Шапка карточки брони (prototype/Prototype.dc.html:1491). Насыщенность заливки (16% против
   15%) и обводка — так в макете, не унификация с sm «на глаз». */
.md {
  height: 26px;
  padding: 0 11px 0 9px;
  font-size: 11.5px;
  background: color-mix(in oklch, var(--tint) 16%, var(--tint-on));
  box-shadow: inset 0 0 0 1px color-mix(in oklch, var(--tint) 34%, transparent);
}
